export default {
  styleOverrides: {
    root: {
      minHeight: "48px",
      "&.Mui-expanded": {
        minHeight: "48px",
      },
      "& .MuiAccordionSummary-content": {
        margin: "13px 0",
        "&.Mui-expanded": {
          margin: "13px 0",
        },
      },
    },
  },
};
